import { render } from "./ClubOutlays.vue?vue&type=template&id=da480146"
import script from "./ClubOutlays.vue?vue&type=script&lang=js"
export * from "./ClubOutlays.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__